import React, { Component } from "react";
import "./createstudy.css";
import { Container, Form, Button, NavLink } from "reactstrap";
import 'react-image-lightbox/style.css';
import Game from "../../../src/components/Picture/ชื่ออาณาจักร.jpg";
import Lightbox from "react-image-lightbox";
class CreateStudy3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  render() {
    const { isOpen } = this.state;
    return (
      <div>
        <Container className="comming">
          <Form className="boxstudy3">
            <h5 className="textstudy">
              เรื่องพัฒนาการทางด้านต่างๆ
              ของประเทศในภูมิภาคเอเชียตะวันออกเฉียงใต้
            </h5>
            <br></br>
            <Form className="b1">
              <h5 className="dd">
                ภูมิภาคเอเชียตะวันออกเฉียงใต้ มีผู้คนตั้งถิ่นฐานนับหมื่นปี
                และก่อตั้งเป็นอาณาจักรมานานกว่า 1000
                ปีแล้วในเกือบทุกส่วนของภูมิภาค เช่น ทวารวดี พุกาม ศรีวิชัย
                กัมพูชา เป็นต้น อีกทั้งมีความเจริญรุ่งเรืองอย่างสูง
                เมื่อชาติตะวันตกเข้ามาค้าขาย และล่าอาณานิคม หลายอาณาจักร
                ยกเว้นไทยต่างตกเป็นอาณานิคมของชาติตะวันตก คือ อังกฤษ ฝรั่งเศส
                ฮอลันดา (เนเธอร์แลนด์) สเปน และสหรัฐอเมริกา
                หลังสงครามโลกครั้งที่ 2
                กลุ่มประเทศอาณานิคมทั้งหลายต่างได้รับเอกราช
                และพยายามพัฒนาประเทศตามพื้นฐานและความสามารถของตน
                ปัจจุบันประเทศในภูมิภาคเอเชียตะวันเฉียงใต้ 10
                ประเทศได้รวมกันเป็นสมาคมอาเซียน
                เพื่อช่วยเหลือและร่วมมือกันในด้านต่าง ๆ
                อันนำไปสู่การเป็นประชาคมอาเซียนในที่สุด
                เพื่อจะได้เข้าใจพัฒนาการของประเทศในภูมิภาคเอเชียตะวันออกเฉียงใต้
                จึงแบ่งการอธิบายออกเป็นสมัยโบราณ สมัยใหม่ และสมัยปัจจุบัน
                ดังต่อไปนี้
              </h5>
            </Form>
            <Form className="b1"><h5 className="textS">พัฒนาการสมัยโบราณ</h5>
            
              <h5 className="dd">
                {" "}
                ภูมิภาคเอเชียตะวันออกเฉียงใต้มีผู้คนอาศัยมานาน
                หลักฐานที่เก่าแก่ที่สุด คือ
                โครงกระดูกมนุษย์ชวาที่ริมฝั่งแม่น้ำโซโลใกล้เมืองตรินิล บนเกาะชวา
                มีอายุประมาณ 500,000 ปีล่วงมาแล้ว
                และเป็นดินแดนที่ได้สร้างสรรค์ความเจริญทัดเทียมกับดินแดนอื่นในเวลาเดียวกัน
                คือ รู้จักการนำโลหะโดยเฉพาะนำสำริดมาใช้ เช่น ที่ดองซอนในเวียดนาม
                บ้านเชียงในไทย และรู้จักเพาะปลูก คือ รู้จักการเพาะปลูกข้าว
                เมื่อประมาณ 6,000
                ปีมาแล้วผู้คนของเอเชียตะวันออกเฉียงใต้สร้างสมความเจริญของตนเอง
                ประกอบกับภูมิภาคเอเชียตะวันออกเฉียงใต้ตั้งอยู่เส้นทางการค้าระหว่างอินเดียกับจีน
                จึงได้รับอิทธิพลทางอารยธรรมจากสองอารยธรรมใหญ่ คือ
                อารยธรรมจีนทางด้านตะวัน-ออก ซึ่งมีอิทธิพลมากในเวียดนาม
                และวัฒนธรรมอินเดียด้านตะวันตก ซึ่งมีอิทธิพลต่อพม่า ไทย ลาว
                และกัมพูชา สำหรับอินโดนีเซียและมาเลเซีย ได้รับอิทธิพลในระยะแรก
                ส่วนฟิลิปปินส์
                อารยธรรมอินเดียและจีนยังแผ่เข้าไม่ถึงสำหรับอารยธรรมอินเดียก่อให้เกิดการพัฒนาการทางประวัติศาสตร์ขึ้นมาในภูมิภาคเอเชียตะวันออกเฉียงใต้
                คือ การตั้งอาณาจักรแบบอินเดีย
              </h5>
            </Form>

            <Form className="b1"><h5 className="textS">
              อาณาจักรสำคัญที่ได้รับอิทธิพลอารยธรรมอินเดีย
            </h5>
            
              <h5 className="dd">
                อิทธิพลของอารยธรรมอินเดียที่มีต่ออาณาจักรต่าง ๆ เหล่านี้ คือ
                แนวความคิดเรื่องพระมหากษัตริย์ที่เป็นเทวราช
                หรือกษัตริย์ผู้ทรงทศพิธราชธรรม กฎหมายตามแนวพระธรรมศาสตร์
                ภาษาสันกฤตและบาลี วรรณกรรมเรื่องรามเกียรติ์และมหาภารตะ
                การใช้พุทธศักราชและจุลศักราช แบบอย่างศิลปกรรม สถาปัตยกรรม
                เป็นต้น อย่างไรก็ตาม
                จะเห็นได้ชัดเจนว่าผู้คนในเอเชียตะวันออกเฉียงใต้มีการเลือกรับอารยธรรมอินเดีย
                เพราะไม่ได้รับระบบวรรณะ
                ซึ่งเป็นการแบ่งแยกผู้คนในสังคมที่ตายตัวเข้ามา
                และยังคงรักษาวัฒนธรรม
                ความเชื่อเรื่องผีสางวิญญาณของตนเองไว้ด้วยกันอิทธิพลของอารยธรรมอินเดียที่มีต่ออาณาจักรต่าง
                ๆ
                ในภูมิภาคเอเชียตะวันออกเฉียงใต้เสื่อมลงตั้งแต่ต้นพุทธ-ศตวรรษที่
                19 เป็นต้นมา
                เพราะศาสนาอิสลามเผยแผ่เข้ามาทางหมู่เกาะของภูมิภาคเอเชียตะวันออกเฉียงใต้
                และการรุกรานของพวกมองโกลที่จีนปกครองต่ออาณาจักรต่าง ๆ
                ที่รับอารยธรรมอินเดีย รวมถึงเกาะชวาสำหรับอาณาจักรเวียดนาม
                จีนปกครองเวียดนามเป็นระยะเวลา 1,000ปี จนปลายพุทธศตวรรษที่ 16
                จึงเป็นอิสระจากจีน มีการสู้รบกับพวกจาม
                จนพวกจามพ่ายแพ้อย่างเด็ดขาดใน
                พ.ศ.2015หลังจากอาณาจักรที่รับอารยธรรมของอินเดียเสื่อมและหมดอำนาจไป
                ดินแดนต่าง ๆ ก็มีการก่อตั้งอาณาจักรขึ้นมาใหม่
                โดยที่อารยธรรมอินเดียมีความสำคัญลดลงไป เช่น ราชวงศ์ตองอูในพม่า
                อาณาจักรสุโขทัย อาณาจักรอยุธยาในไทย เป็นต้น พอถึงพุทธศตวรรษที่
                21
                ภูมิภาคเอเชียตะวันออกเฉียงใต้เริ่มมีการเปลี่ยนแปลงจากการเข้ามาของชาติตะวันตก
              </h5>
            </Form>

            <Form className="b1"><h5 className="textS">
              สมัยโบราณหรืออาจักรยุคโบราณ มีการพัฒนาการทางด้านต่าง ๆ ดังนี้
            </h5>
            
              <h5 className="dd">
                1. พัฒนาการทางด้านการเมืองการปกครอง มีลักษณะที่สำคัญ คือ
                มีสถาบันกษัตริย์เป็นแกนสำคัญ ในพม่า ไทย ลาว
                ที่นับถือพระพุทธศาสนา มีพระมหากษัตริย์เป็นสถาบันหลักในมลายู
                (มาเลเซีย) ชวา (อินโดนีเซีย) ซึ่งนับถือศาสนาอิสลาม มีสุลต่าน
                ส่วนในเวียดนาม ซึ่งได้รับอิทธิพลอารยธรรมจีน มีจักรพรรดิ หรือ
                หว่างเด๋
                ส่วนในฟิลิปปินส์ยังไม่ได้เป็นประเทศมีเพียงหัวหน้าหรือผู้นำของแต่ละชนเผ่า
                ในช่วงเวลานี้ อำนาจของอาณาจักรต่าง ๆ
                ขึ้นอยู่กับความเข้มแข็งและความสามารถของประมุข เช่น
                พระเจ้าบุเรงนองของพม่า พ่อขุนรามคำแหงมหาราชของไทยสมัยสุโขทัย
                พระเจ้าชัยวรมันที่ 7 ของขอมหรือเขมรโบราณ เป็นต้น ดังนั้น
                อาณาจักรในสมัยนี้จึงมีการทำสงครามแย่งชิงอำนาจภายใน
                และการทำสงครามระหว่างอาณาจักรต่าง ๆ อยู่มาก
                ฝ่ายชนะก็จะมีการกวาดต้อนผู้คน ยึดทรัพย์สิน ของมีค่า
                รวมทั้งงานศิลปวัตถุ กลับไปยังบ้านเมืองของตน
              </h5>
              <h5 className="dd">
                2. พัฒนาการทางด้านเศรษฐกิจ ลักษณะสำคัญ คือ
                เป็นเศรษฐกิจแบบยังชีพหรือเศรษฐกิจแบบพึ่งตนเอง
                ส่วนใหญ่ประกอบอาชีพการเกษตร ทำนาเป็นหลักและปลูกพืชผลอื่น ๆ
                เพื่อบริโภคในครัวเรือน
                ถ้ามีเหลือก็ขายหรือเปลี่ยนเป็นส่วยให้กับทางราชการ
                มีการเลี้ยงสัตว์ และเก็บหาของป่าเพื่อใช้ประโยชน์และขาย
                มีแรงงานคนและสัตว์ เช่น โค
                กระบือเป็นแรงงานสำคัญในการผลิตการค้าแบบเก่ามีทั้งการค้าภายในและการค้าภายนอก
                ที่สำคัญคือ การค้าทางทะเล โดยอาศัยลมมรสุมในการเดินเรือ
                ตลาดสำคัญคือ จีน ญี่ปุ่น ทางด้านตะวันตก และอินเดีย เปอร์เซีย
                ทางด้านตะวันตก โดยมีเมืองท่าสำคัญระยะแรกอยู่ที่เกาะ-สุมาตรา
                ต่อมาคือ เมืองมะละกา พระนครศรีอยุธยา เป็นต้น สินค้าสำคัญ เช่น
                ของป่า หนังสัตว์ เครื่องเทศ พริกไทย เป็นต้น
              </h5>
              <h5 className="dd">
                3. พัฒนาการด้านสังคมและวัฒนธรรม ลักษณะที่สำคัญเป็นสังคมชนชั้น
                คือ ชนชั้นปกครองหรือมูลนาย กับผู้ถูก-ปกครอง หรือราษฎรสามัญ ทาส
                ส่วนพระสงฆ์ได้รับการเคารพยกย่องจากสังคม
                และผู้ที่เคยบวชเรียนมีโอกาสดีในการเลื่อนฐานะทางสังคม
                ทำนองเดียวกันในสังคมมุสลิม ผู้ที่เคยไปแสวงบุญที่นครเมกกะ
                ก็ได้รับการยกย่องเช่นเดียวกัน
              </h5>
            </Form>
            <img className="photo3"
              width="1000"
              height="1000"
          onClick={() => this.setState({ isOpen: true })}
          src={Game}
          alt="QRcode"
          
        ></img>
        {isOpen && (
          <Lightbox
            mainSrc={Game}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
          
            <p h5 align="center">
              <Button href="/study" outline color="warning">
                ย้อนกลับ
              </Button>{" "}
            </p>
            <p h5 align="center">
              <Button href="/createStudy4" outline color="primary">
                บทถัดไป
              </Button>{" "}
            </p>
          </Form>
          
        </Container>
        <div className="footer text-footer">
          <p>Surasak Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>
          <NavLink href="https://surasak783023869.wordpress.com/">
            ช่องทางการติดต่อ
          </NavLink>
        </div>
      </div>
    );
  }
}

export default CreateStudy3;
